import amplitude from "amplitude-js";

interface LogFactorArgs {
  factorName: string;
}

interface LogFactorArgs {
  factorName: string;
}

interface LogPageArgs {
  pageName?: string;
  subsectionName?: string;
}

interface AmplitudeInitArgs {
  apiKey?: string | null;
  userId?: string | null;
  deviceId?: string | null;
}

declare global {
  interface Window {
    _AthenaIdentityAmplituedEventWhitelist: string[];
  }
}

function isWhiteListedEvent(eventName: string): boolean {
  // _AthenaIdentityAmplituedEventWhitelist is defined in
  // https://bitbucket.athenahealth.com/projects/IAM/repos/identity-amplitude-event-whitelist/browse
  if (
    window._AthenaIdentityAmplituedEventWhitelist &&
    Array.isArray(window._AthenaIdentityAmplituedEventWhitelist)
  ) {
    return window._AthenaIdentityAmplituedEventWhitelist.includes(eventName);
  }
  // This whitelist is to help us reduce the cost on Amplitude, not an access restriction.
  // So if there is an issue getting the whitelist, we don't want to miss any necessary logs,
  // and we will just log all events.
  return true;
}

const AMPLITUDE_EVENT_PREFIX = "ManageProfile::";
export function initialize({
  apiKey,
  userId,
  deviceId,
}: AmplitudeInitArgs): void {
  amplitude.getInstance().init(apiKey ?? "", userId ?? "");
  amplitude.getInstance().setDeviceId(deviceId ?? "");
}

export function logLandingEvent({ pageName }: LogPageArgs): void {
  if (!pageName || pageName === "") {
    return logEventInternal("Landing");
  }
  return logEventInternal(`${pageName}::Landing`);
}

export function logEditPassword(): void {
  return logEventInternal("EditPasswordButtonClick");
}

export function logEditFactors(): void {
  return logEventInternal("EditFactorsButtonClick");
}

export function logEditPrivacySettings(): void {
  return logEventInternal("EditPrivacySettingsButtonClick");
}

export function logSaveButtonClick({ pageName }: LogPageArgs): void {
  return logEventInternal(`${pageName}::SaveButtonClick`);
}

export function logResetAllPrivacySettingsInitiated(): void {
  return logEventInternal("PrivacySettings::ResetAllButtonClick");
}

export function logRemoveFactorInitiated({ factorName }: LogFactorArgs): void {
  return logEventInternal("EditFactors::RemoveButtonClick", { factorName });
}

export function logEnrollFactorInitiated({ factorName }: LogFactorArgs): void {
  return logEventInternal("EditFactors::SetUpButtonClick", { factorName });
}

export function logEventInternal(
  baseEventName: string,
  eventProperties?: unknown,
): void {
  const eventName = `${AMPLITUDE_EVENT_PREFIX}${baseEventName}`;
  if (eventName && isWhiteListedEvent(eventName)) {
    amplitude.getInstance().logEvent(eventName, eventProperties);
  }
}

export function logResetAllConfirmButtonClick(): void {
  return logEventInternal("PrivacySettings::ResetAll::ConfirmButtonClick");
}

export function logResetAllCancelButtonClick(): void {
  return logEventInternal("PrivacySettings::ResetAll::CancelButtonClick");
}

export function logCancelButtonClick({ pageName }: LogPageArgs): void {
  return logEventInternal(`${pageName}::CancelButtonClick`);
}

export function logTwoStepVerificationToggled(isChecked: boolean): void {
  const eventName = isChecked ? "MFAToggleOn" : "MFAToggleOff";
  return logEventInternal(eventName);
}

